import { gql } from 'graphql.macro'

export default gql`
  fragment ReadingTypeFragment on ReadingType {
    id
    name
    type
  }
`
